import type { RefObject } from "react";
import ConversationItem from "./ConversationItem";
import ConversationListEmpty from "./ConversationListEmpty";
import type { Conversation, InboxDemoIcons } from "../data/types";

type ConversationListProps = {
  conversations: Conversation[];
  selectedConversationId: string;
  icons: InboxDemoIcons;
  listRef: RefObject<HTMLDivElement | null>;
  onSelect: (conversationId: string) => void;
  onUserIntent: () => void;
};

export default function ConversationList({
  conversations,
  selectedConversationId,
  icons,
  listRef,
  onSelect,
  onUserIntent,
}: ConversationListProps) {
  return (
    <div
      className="inbox-demo-scroll flex min-h-0 flex-1 flex-col gap-2 pr-1"
      ref={listRef}
      onScroll={onUserIntent}
      onWheel={onUserIntent}
    >
      {conversations.length === 0 ? (
        <ConversationListEmpty />
      ) : (
        conversations.map((conversation) => (
          <ConversationItem
            conversation={conversation}
            icons={icons}
            key={conversation.id}
            selected={conversation.id === selectedConversationId}
            onSelect={(id) => {
              onUserIntent();
              onSelect(id);
            }}
          />
        ))
      )}
    </div>
  );
}
